import { render, staticRenderFns } from "./CrudModal.vue?vue&type=template&id=77fc3d2b&scoped=true"
import script from "./CrudModal.vue?vue&type=script&lang=js"
export * from "./CrudModal.vue?vue&type=script&lang=js"
import style0 from "./CrudModal.vue?vue&type=style&index=0&id=77fc3d2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fc3d2b",
  null
  
)

export default component.exports